import { DnsApiClient } from '@fourthwall/services/dist/DnsApiClient';
import { useMutation } from '@tanstack/react-query';
export const createDomainMutationKey = 'createDomain';
export const useCreateDomainMutation = () => {
    const createDomainMutation = useMutation({
        mutationFn: async (payload) => (await DnsApiClient.createDomain(payload)).data,
        mutationKey: [createDomainMutationKey],
        onError: undefined,
    });
    return { createDomainMutation };
};
